// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"s":"s","m":"m","l":"l"};

function sizeToJs(param) {
  return param;
}

function sizeFromJs(param) {
  return _map[param];
}

function textfield(size, isFocused, hasError, isDarkMode, textPadding) {
  return Cn.fromList({
    hd: "border rounded-sm pr-4 tracking-wide transition w-full ease-in duration-200",
    tl: {
      hd: textPadding,
      tl: {
        hd: isFocused ? "border-links" : "",
        tl: {
          hd: hasError ? "border-alert" : (
              isDarkMode ? "border-asphalt" : "border-gray-main"
            ),
          tl: {
            hd: isDarkMode ? "text-white bg-transparent" : "text-black",
            tl: {
              hd: size === "m" ? "py-[11px] text-sm" : (
                  size === "s" ? "py-1.5 text-sm" : "py-3 text-base"
                ),
              tl: {
                hd: Cn.on(Cn.fromList({
                  hd: isDarkMode ? "border-white" : "border-gray-main",
                  tl: {
                    hd: "box-border",
                    tl: /* [] */ 0
                  }
                }), isFocused),
                tl: {
                  hd: Cn.on(isDarkMode ? "hover:border-white" : "hover:border-gray-main", !isFocused && !hasError),
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  });
}

const Styles = {
  textfield: textfield
};

function TextField(Props) {
  let className = Props.className;
  let valueOpt = Props.value;
  let name = Props.name;
  let placeholderOpt = Props.placeholder;
  let type_Opt = Props.type_;
  let sizeOpt = Props.size;
  let hasErrorOpt = Props.hasError;
  let autoFocusOpt = Props.autoFocus;
  let autoCompleteOpt = Props.autoComplete;
  let disabledOpt = Props.disabled;
  let readOnlyOpt = Props.readOnly;
  let requiredOpt = Props.required;
  let multilineOpt = Props.multiline;
  let isFocusedOpt = Props.isFocused;
  let isDarkModeOpt = Props.isDarkMode;
  let pattern = Props.pattern;
  let validatedValue = Props.validatedValue;
  let textPaddingOpt = Props.textPadding;
  let tabIndex = Props.tabIndex;
  let minLength = Props.minLength;
  let maxLength = Props.maxLength;
  let onChange = Props.onChange;
  let onFocus = Props.onFocus;
  let inputRef = Props.inputRef;
  let onBlur = Props.onBlur;
  let rowsOpt = Props.rows;
  const value = valueOpt !== undefined ? valueOpt : "";
  const placeholder = placeholderOpt !== undefined ? placeholderOpt : "";
  const type_ = type_Opt !== undefined ? type_Opt : "text";
  const size = sizeOpt !== undefined ? sizeOpt : "l";
  const hasError = hasErrorOpt !== undefined ? hasErrorOpt : false;
  const autoFocus = autoFocusOpt !== undefined ? autoFocusOpt : false;
  const autoComplete = autoCompleteOpt !== undefined ? autoCompleteOpt : "off";
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const readOnly = readOnlyOpt !== undefined ? readOnlyOpt : false;
  const required = requiredOpt !== undefined ? requiredOpt : false;
  const multiline = multilineOpt !== undefined ? multilineOpt : false;
  const isFocused = isFocusedOpt !== undefined ? isFocusedOpt : false;
  const isDarkMode = isDarkModeOpt !== undefined ? isDarkModeOpt : false;
  const textPadding = textPaddingOpt !== undefined ? textPaddingOpt : "pl-4";
  const rows = rowsOpt !== undefined ? rowsOpt : 4;
  const inputRef$1 = Belt__Belt_Option.mapWithDefault(inputRef, React.useRef(null), (function (inputRef) {
    return inputRef;
  }));
  React.useEffect((function () {
    if (isFocused) {
      const __x = inputRef$1.current;
      Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
        return el.focus();
      }));
    }
    
  }), [
    isFocused,
    inputRef$1
  ]);
  const className$1 = Cn.fromList({
    hd: textfield(size, isFocused, hasError, isDarkMode, textPadding),
    tl: {
      hd: Cn.take(className),
      tl: /* [] */ 0
    }
  });
  let tmp;
  if (multiline) {
    let tmp$1 = {
      ref: inputRef$1,
      className: className$1,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      disabled: disabled,
      placeholder: placeholder,
      readOnly: readOnly,
      required: required,
      rows: rows,
      value: value,
      onFocus: (function (param) {
        Curry._1(onFocus, undefined);
      }),
      onBlur: (function (param) {
        Curry._1(onBlur, undefined);
      }),
      onChange: (function (ev) {
        Curry._1(onChange, ev.target.value);
      })
    };
    if (tabIndex !== undefined) {
      tmp$1.tabIndex = Caml_option.valFromOption(tabIndex);
    }
    if (name !== undefined) {
      tmp$1.name = Caml_option.valFromOption(name);
    }
    tmp = JsxRuntime.jsx("textarea", tmp$1);
  } else {
    let tmp$2 = {
      ref: inputRef$1,
      className: className$1,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      disabled: disabled,
      placeholder: placeholder,
      readOnly: readOnly,
      required: required,
      type: type_,
      value: value,
      onFocus: (function (param) {
        Curry._1(onFocus, undefined);
      }),
      onBlur: (function (param) {
        Curry._1(onBlur, undefined);
      }),
      onChange: (function (ev) {
        Curry._1(onChange, ev.target.value);
      })
    };
    if (tabIndex !== undefined) {
      tmp$2.tabIndex = Caml_option.valFromOption(tabIndex);
    }
    if (maxLength !== undefined) {
      tmp$2.maxLength = Caml_option.valFromOption(maxLength);
    }
    if (minLength !== undefined) {
      tmp$2.minLength = Caml_option.valFromOption(minLength);
    }
    if (name !== undefined) {
      tmp$2.name = Caml_option.valFromOption(name);
    }
    if (pattern !== undefined) {
      tmp$2.pattern = Caml_option.valFromOption(pattern);
    }
    tmp = JsxRuntime.jsx("input", tmp$2);
  }
  let tmp$3;
  tmp$3 = validatedValue !== undefined && validatedValue.TAG !== /* Ok */ 0 ? JsxRuntime.jsx("p", {
      children: validatedValue._0,
      className: "mt-1 text-red-500 text-sm"
    }) : null;
  return JsxRuntime.jsxs("div", {
    children: [
      tmp,
      tmp$3
    ]
  });
}

const make = TextField;

export {
  sizeToJs,
  sizeFromJs,
  Styles,
  make,
}
/* react Not a pure module */
